import { Link } from "gatsby"

import { Button, ButtonUnstyled, ViewButton } from "./styles"
import ToTopButton from "./to-top"

const ButtonAnchor = Button.withComponent("a")
const ButtonLink = Button.withComponent(Link)

export { ButtonAnchor, ButtonLink, ButtonUnstyled, ViewButton, ToTopButton }

export default Button
